import { lazyWithRetry } from 'shared/lazy';
export const MifidLazy = lazyWithRetry(() => import('./Mifid'));
